import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { customerSchema, envelopeSchema } from '../lib/schemas';

export interface Customer {
  id: string;
  created_at?: string;
  updated_at?: string;
  created_by?: string;
  updated_by?: string;
  customer_id?: string | null;
  customer_name?: string | null;
  country?: string | null;
  postal_code?: string | null;
  city?: string | null;
  street?: string | null;
  street_no?: string | null;
}

export type CustomerInput = Omit<
  Customer,
  'id' | 'created_at' | 'updated_at' | 'created_by' | 'updated_by'
>;

export const customerService = {
  async getAll(): Promise<Customer[]> {
    const result = await apiClient.get(apiUrl.customers(), {
      validate: envelopeSchema('customers', z.array(customerSchema)),
      deduplicate: true,
      context: 'getCustomers',
    });
    return result.customers;
  },

  async create(row: CustomerInput): Promise<Customer> {
    const result = await apiClient.post(apiUrl.customers(), row, {
      validate: envelopeSchema('customer', customerSchema),
      context: 'createCustomer',
    });
    return result.customer;
  },

  async update(id: string, row: CustomerInput): Promise<Customer> {
    const result = await apiClient.put(apiUrl.customers(id), row, {
      validate: envelopeSchema('customer', customerSchema),
      context: 'updateCustomer',
    });
    return result.customer;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(apiUrl.customers(id), {
      context: 'deleteCustomer',
    });
  },
};
